import {
  NewFooter,
  NewHeader,
  SegmentAnalytics
} from "components";
import React, {useEffect, useState} from "react";

import Head from "next/head";
import HeaderV2 from "components/HeaderV2";
import HeroSection from "components/AboutUsNew/HeroSection";
import HowWeWork from "components/AboutUsNew/HowWeWork";
import IndexPage from "components/AboutUsNew/about-us-letter";
import InvestorSection from "components/AboutUsNew/InvestorSection";
import MoneyOrder from "components/AboutUsNew/MoneyOrder";
import PartnerGlobalStyle from "static/next/css/PartnerGlobalStyle";
import PersonCard from "components/AboutUsNew/Founders";
import PressSection from "components/AboutUsNew/PressSection";
import TeamSection from "components/AboutUsNew/TeamSection";
import TestimonialBento from "components/AboutUsNew/TestimonialBento";
import TimelineNew from "components/AboutUsNew/TimelineNew";
import {ToastContainer} from "react-toastify";
import {WealthyEnv} from "helpers";
import WhatWeBelieve from "components/AboutUsNew/WhatWeBelieve";
import styled from "styled-components";
import {Register} from "components/NewPartners";
import GetStartedModal from "components/commons/Login/GetStartedModal";


function aboutUsNew ({
  seoData,
  heroData,
  foundersData,
  teamData,
  teamSectionData,
  believeData,
  howWeWorkData,
  investorData,
  pressData,
  moneyOrderData,
  timelineData,
  timelineSectionData,
  testimonialData
}) {
  const [showLetter, setShowLetter] = useState(false);
  const [toggleRegister, setToggleRegister] = useState(false);
  const [toggleModal, setToggleModal] = useState(false);

  const handleCloseModal = () => {
    setToggleModal(false);
    const currentScroll = window.scrollY;
    window.history.replaceState(null, "", window.location.pathname);
    window.scrollTo(0, currentScroll);
  };

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash;
      const currentScroll = window.scrollY;

      setToggleRegister(hash === "#register");
      setToggleModal(hash === "#login");

      requestAnimationFrame(() => {
        window.scrollTo(0, currentScroll);
      });
    };

    handleHashChange();
    window.addEventListener("hashchange", handleHashChange);

    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, []);

  if (showLetter) {
    return <IndexPage />;
  } else {
    return (
      <PageContainer>

        <Head>
          <title>{seoData.title}</title>
          <meta content={seoData.title} name="title" />
          <meta content={seoData.description} name="description" />
          <meta content={seoData.keywords} name="keywords" />

          <meta property="og:type" content="website" />
          <meta property="og:url" content={seoData.canonicalUrl} />
          <meta property="og:title" content={seoData.title} />
          <meta property="og:description" content={seoData.description} />
          <meta property="og:image" content={seoData.ogImage} />
          <meta property="og:site_name" content="Wealthy" />

          <meta property="twitter:card" content="summary_large_image" />
          <meta name="twitter:site" content="@wealthy_in" />
          <meta property="twitter:url" content={seoData.canonicalUrl} />
          <meta property="twitter:title" content={seoData.title} />
          <meta property="twitter:description" content={seoData.description} />
          <meta property="twitter:image" content={seoData.ogImage} />

          <link href={seoData.canonicalUrl} rel="canonical" />
          <link href="https://i.wlycdn.com/wealthy-home-page/new-fav-icon.png" rel="icon" />
          <link rel="preconnect" href="https://i.wlycdn.com" crossOrigin="anonymous" />
          {heroData?.heroImageMob ? (
            <link rel="preload" as="image" href={heroData.heroImageMob} />
          ) : null}
          {WealthyEnv.IS_PRODUCTION ? (
            <link
              rel="preload"
              href={`${WealthyEnv.WEALTHY_FONT}/maven-pro-regular.woff`}
              as="font"
              type="font/woff"
              crossOrigin="anonymous"
            />
          ) : null}

          {seoData.schema && (
            <script
              type="application/ld+json"
              dangerouslySetInnerHTML={{
                __html: JSON.stringify(seoData.schema)
              }}
            />
          )}

          <link as="style" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick.min.css" rel="preload" />
          <link as="style" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick-theme.min.css" rel="preload" />
          <link href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick.min.css" rel="stylesheet" />
          <link href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick-theme.min.css" rel="stylesheet" />
          <link href="/static/next/css/header-footer.css" rel="stylesheet" />
          <script
            defer
            src={`https://www.google.com/recaptcha/api.js?render=${WealthyEnv.RECAPTCHA_SITEKEY}`}
          />
        </Head>
        <SegmentAnalytics />
        <ToastContainer />

        <div id="login" style={{display: toggleModal ? "block" : "none"}}>
          <GetStartedModal
            setToggleModal={handleCloseModal}
            toggleModal={toggleModal}
          />
        </div>

        <div id="register">
          <Register />
        </div>

        {<PartnerGlobalStyle />}

        <HeaderV2
          backgroundColor={"#f8f5ff"}
          color={"#000000"}
          logo={`${WealthyEnv.HOMEPAGE_CDN_URL}/wealthy-new-purple-logo.svg`}
          isPartnerPage
        />

        <main id="main-content">
        <HeroSection heroData={heroData} />

        <Section>
          <SectionInner>
            <SectionTitleCenter1>{foundersData.sectionTitle}</SectionTitleCenter1>
            <CardsRow>
              {foundersData.founders.map((founder, index) => (
                <PersonCard
                  key={index}
                  background={founder.background}
                  description={founder.description}
                  image={founder.image}
                  linkedinUrl={founder.linkedinUrl}
                  name={founder.name}
                  position={founder.position}
                />
              ))}
            </CardsRow>
            <LetterButton
              href="#"
              onClick={e => {
                e.preventDefault();
                setShowLetter(true);
              }}
            >
              {foundersData.letterButtonText} &nbsp;&nbsp;<span>✉️</span>
            </LetterButton>
          </SectionInner>
        </Section>
        <InvestorSection investorData={investorData} />

        <Section>
          <SectionInner>
            <SectionTitleCenter>{teamSectionData.title}</SectionTitleCenter>
            <SectionSubtitle>
            {teamSectionData.subtitle.normal}
            <span>{teamSectionData.subtitle.highlight}</span>
            </SectionSubtitle>
            <TeamSection team={teamData} />
          </SectionInner>
        </Section>

        <WhatWeBelieve believeData={believeData} />
        <HowWeWork howWeWorkData={howWeWorkData} />
        {<TimelineNew timelineData={timelineData} timelineSectionData={timelineSectionData} />}
        <TestimonialBento testimonialData={testimonialData} />
        <PressSection pressData={pressData} />
        <MoneyOrder moneyOrderData={moneyOrderData} />
        </main>
        <NewFooter />

      </PageContainer>
    );
  }
}

export async function getStaticProps () {
  const seoData = {
    title: "Grow Your Business with Wealthy – Become a Mutual Fund Distributor",
    description: "Partner with Wealthy to expand your business with a wide range of products, advanced portfolio tracking, and automated payouts.",
    keywords: "Wealthy, Wealthy India, mutual fund distributor, mutual fund platform, investment professionals, financial entrepreneurs, PMS, insurance, fixed deposits, debentures, MFD tools, distributor platform, investment products, grow business, revenue share, partner program, mutual funds online, client management tools, portfolio tracking, digital investment platform India, financial product distribution, NISM, commission of mutual fund distributor",
    ogImage: "https://i.wlycdn.com/wealthy-home-page/partner-metaimage-new.png",
    canonicalUrl: `${WealthyEnv.URL}/partner/about-us`,
    schema: {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: `${WealthyEnv.URL}`
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Partner",
          item: `${WealthyEnv.URL}/partner`
        },
        {
          "@type": "ListItem",
          position: 3,
          name: "About Us",
          item: `${WealthyEnv.URL}/partner/about-us`
        }
      ]
    }
  };

  const heroData = {
    title: ["Future-Ready", "Investment Solutions"],
    subtitle: "Our Mission is to empower Wealth Professionals with advanced AI-based technology, investment products, and dedicated human support to grow their business",
    heroImage: `${WealthyEnv.HOMEPAGE_CDN_URL}/hero-image-desktop-about-us.svg`,
    heroImageMob: `${WealthyEnv.HOMEPAGE_CDN_URL}/hero-image-about-us.png`
  };

  const foundersData = {
    sectionTitle: "Our Founders",
    letterButtonText: "Letter from the Founders",
    founders: [
      {
        background: "#F9F6FF",
        description: "An IIT Bombay graduate, Aditya worked with MNC consulting firms and was advising friends and family on their investments before starting Wealthy.",
        image: `${WealthyEnv.HOMEPAGE_CDN_URL}/founder-card-aditya-avatar-about-us.jpg`,
        linkedinUrl: "https://www.linkedin.com/in/adagarwal/",
        name: "Aditya Agarwal",
        position: "Co-Founder"
      },
      {
        background: "#FDFCF6",
        description: "An engineer from IIT Madras and a MBA graduate from IIM-Ahmedabad, Prashant was advising family offices at Morgan Stanley before starting Wealthy.",
        image: `${WealthyEnv.HOMEPAGE_CDN_URL}/founder-card-prashant-avatar-about-us.jpg`,
        linkedinUrl: "https://www.linkedin.com/in/prashant-gupta-1b884b6/",
        name: "Prashant Gupta",
        position: "Co-Founder"
      }
    ]
  };

  const teamData = [
    {
      image: `${WealthyEnv.HOMEPAGE_CDN_URL}/our-team-ashish-about-us.svg`,
      name: "Ashish Saligram",
      position: "Head of Marketing",
      experience: "Ex-Byju's and Hiveminds",
      linkedin: "https://www.linkedin.com/in/ashish-saligram/"
    },
    {
      image: `${WealthyEnv.HOMEPAGE_CDN_URL}/our-team-savant-about-us.svg`,
      name: "Chandan Savant",
      position: "National Sales Head, Online",
      experience: "Ex-HDFC and Axis AMC",
      linkedin: "https://www.linkedin.com/in/thinksavant/"
    },
    {
      image: `${WealthyEnv.HOMEPAGE_CDN_URL}/our-team-jaya-about-us.svg`,
      name: "Jaya Singh",
      position: "Chief Strategy Officer",
      education: "IISWBM",
      experience: "Ex-Citibank",
      linkedin: "https://www.linkedin.com/in/jaya-singh-63a48a193/"
    },
    {
      image: `${WealthyEnv.HOMEPAGE_CDN_URL}/our-team-nikarika-about-us.svg`,
      name: "Niharika Tripathi",
      position: "Head of Products",
      education: "IIM Mumbai",
      experience: "Ex-Citibank",
      linkedin: "https://www.linkedin.com/in/niharika-tripathi-1a593a4/"
    },
    {
      image: `${WealthyEnv.HOMEPAGE_CDN_URL}/our-team-shiva-about-us.svg`,
      name: "Shiva Kumar",
      position: "Head of Partner Recruitment",
      education: "IIM Calcutta",
      experience: "Ex-OLA",
      linkedin: "https://www.linkedin.com/in/shiva-kumar-nagendra-52a6b757/"
    },
    {
      image: `${WealthyEnv.HOMEPAGE_CDN_URL}/our-team-somit-about-us.svg`,
      name: "Somit Srivastava",
      position: "Chief Technology Officer",
      education: "BIT Mesra",
      experience: "Ex-Olacabs, Hashedln, IBM",
      linkedin: "https://www.linkedin.com/in/somitsrivastava/"
    },
    {
      image: `${WealthyEnv.HOMEPAGE_CDN_URL}/our-team-ujjwal-about-us.svg`,
      name: "Ujjwal Banerjee",
      position: "National Sales Head, Branches",
      experience: "Ex-NJ and Prudent",
      linkedin: "https://www.linkedin.com/in/ujjwal-banerjee-3a668719/"
    },
    {
      image: `${WealthyEnv.HOMEPAGE_CDN_URL}/our-team-vivek-about-us.svg`,
      name: "Vivek Singh",
      position: "Head of Human Resources",
      education: "XLRI Jamshedpur",
      experience: "Army Veteran and Ex-Renault",
      linkedin: "https://www.linkedin.com/in/capt-vivek-singh-62602283/"
    }
  ];

  const teamSectionData = {
    title: "Our Team",
    subtitle: {
      normal: "We're a team of investment experts with the pedigree of IIT-IIM and decades of experience in big names such as ",
      highlight: "Citibank, Morgan Stanley, Edelweiss General Insurance, and Axis Mutual Fund."
    }
  };

  const believeData = {
    title: "What we Believe",
    subtitle: "Our Values and beliefs through which we help your Partners and Clients achieve financial goals and prosper",
    beliefs: [
      {
        icon: `${WealthyEnv.HOMEPAGE_CDN_URL}/what-we-believe-card-logo1-about-us.jpg`,
        mobileImage: `${WealthyEnv.HOMEPAGE_CDN_URL}/what-we-believe-card-image2-about-us.jpg`,
        title: "Client Success First",
        description: "By helping you place client needs first, we set you up for long term success in wealth management",
        image: `${WealthyEnv.HOMEPAGE_CDN_URL}/what-we-believe-card-image2-about-us.jpg`
      },
      {
        icon: `${WealthyEnv.HOMEPAGE_CDN_URL}/what-we-believe-card-logo2-about-us.jpg`,
        mobileImage: `${WealthyEnv.HOMEPAGE_CDN_URL}/keep-it-simple-mobile-image.jpg`,
        title: "Keep It Simple",
        description: "We push the boundaries of tech and design to help you and your clients have the best possible investing experience",
        image: `${WealthyEnv.HOMEPAGE_CDN_URL}/what-we-believe-card-image3-about-us.jpg`
      },
      {
        icon: `${WealthyEnv.HOMEPAGE_CDN_URL}/what-we-believe-card-logo3-about-us.jpg`,
        mobileImage: `${WealthyEnv.HOMEPAGE_CDN_URL}/what-we-believe-card-image1-about-us.jpg`,
        title: "Compounding",
        description: "We talk a lot about compounding wealth but we believe if you focus on getting 1% better each day your efforts will compound – in business and wealth.",
        image: `${WealthyEnv.HOMEPAGE_CDN_URL}/what-we-believe-card-image1-about-us.jpg`
      }
    ]
  };

  const howWeWorkData = {
    title: "Where we work",
    subtitle: "The talented team of customer support professionals, engineers, and product researchers are dedicated to making Wealthy a platform that will transform the lives of Wealth Professionals in India and beyond.",
    subtitleMobile: "Our Values and beliefs through which we help your Partners and Clients achieve financial goals and prosper",
    mapImage: `${WealthyEnv.HOMEPAGE_CDN_URL}/india-map-updated-homepage.png`,
    mobImage: `${WealthyEnv.HOMEPAGE_CDN_URL}/india-map-updated-mob.png`,
    infoBlocks: [
      {
        title: "40+ offices",
        subtitle: "Across India"
      },
      {
        title: "400+ Team Members",
        subtitle: "Across cities and countries"
      },
      {
        title: "Making Investment Accessible",
        subtitle: "Our Passion at wealthy"
      }
    ]
  };

  const investorData = {
    title: "Backed by Marquee Investors",
    investors: [
      {image: `${WealthyEnv.HOMEPAGE_CDN_URL}/investor-emvs-logo-about-us.jpg`},
      {image: `${WealthyEnv.HOMEPAGE_CDN_URL}/investor-sav-logo-about-us.jpg`},
      {image: `${WealthyEnv.HOMEPAGE_CDN_URL}/investor-bii-logo-about-us.png`},
      {image: `${WealthyEnv.HOMEPAGE_CDN_URL}/investor-aw-logo-about-us.jpg`},
      {image: `${WealthyEnv.HOMEPAGE_CDN_URL}/investor-gc-logo-about-us.jpg`},
      {image: `${WealthyEnv.HOMEPAGE_CDN_URL}/investor-vh-logo-about-us.jpg`}
    ]
  };

  const pressData = {
    title: "In the press",
    articles: [
      {
        image: `${WealthyEnv.HOMEPAGE_CDN_URL}/press-section-image1-about-us.png`,
        logo: `${WealthyEnv.HOMEPAGE_CDN_URL}/press-section-bs-logo-about-us.png`,
        logoAlt: "",
        title: "How to approach sector-specific stocks & sector-specific funds? Aditya Agarwal explains",
        link: "https://www.business-standard.com/article/companies/wealthy-in-raises-rs-56-crore-in-funding-round-led-by-alpha-wave-122020801920_1.html",
        linkText: "Tap to read"
      },
      {
        image: `${WealthyEnv.HOMEPAGE_CDN_URL}/press-section-image2-about-us.png`,
        logo: `${WealthyEnv.HOMEPAGE_CDN_URL}/press-section-en-logo-about-us.png`,
        logoAlt: "",
        title: "Wealthy.in Sets Out to Assist the Average Indian to Make Wise Investment Decisions",
        link: "https://entrackr.com/2024/10/wealthys-revenue-shots-up-over-2x-with-sound-economics/",
        linkText: "Tap to read"
      },
      {
        image: `${WealthyEnv.HOMEPAGE_CDN_URL}/press-section-image3-about-us.png`,
        logo: `${WealthyEnv.HOMEPAGE_CDN_URL}/press-section-yourstory-logo-about-us.jpg`,
        logoAlt: "",
        title: "How to approach sector-specific stocks & sector-specific funds? Aditya Agarwal explains",
        link: "https://yourstory.com/2020/01/bengaluru-fintech-startup-wealthy",
        linkText: "Tap to read"
      }
    ]
  };

  const moneyOrderData = {
    title: "Money Order",
    subtitle: "Your weekly fix of money and investing insights",
    planeImage: `${WealthyEnv.HOMEPAGE_CDN_URL}/paper-plane.png`,
    spotifyImage: `${WealthyEnv.HOMEPAGE_CDN_URL}/spotify-icon.png`,
    spotifyLink: "https://open.spotify.com/show/6HfF0jN67vAn0VWxmBLBB5",
    descriptionItems: [
      "Latest news that matters to you",
      "Insights backed by data",
      "Quick practical tips for wealth creation"
    ]
  };

  const timelineData = [
    {
      year: "2015",
      milestone: "Wealthy Was Founded",
      details: "Becomes the first platform to offer instant KYC",
      visualElement: "1.5 M*",
      hasImage: true,
      imageUrl: `${WealthyEnv.HOMEPAGE_CDN_URL}/hero-founder-letter-about-us.jpg`
    },
    {
      year: "2019",
      milestone: "Seed Funding",
      details: "Raised by Good Capital and EMVC",
      visualElement: "1.5 M*",
      hasImage: true,
      imageUrl: `${WealthyEnv.HOMEPAGE_CDN_URL}/our-journey-card-about-us.jpg`
    },
    {
      year: "2020",
      milestone: "Shifted Business Focus during Covid",
      details: "Helped more individuals become Wealth Professionals and Entrepreneurs",
      visualElement: null,
      hasImage: true,
      imageUrl: `${WealthyEnv.HOMEPAGE_CDN_URL}/our-journey-card-2020-about-us.jpg`
    },
    {
      year: "2022",
      milestone: "Series A Funding ",
      details: "Raised $7.5 Million by Alpha Wave Global",
      visualElement: "7.5 M*",
      hasImage: true,
      imageUrl: `${WealthyEnv.HOMEPAGE_CDN_URL}/our-journey-card-2022-about-us.jpg`
    },
    {
      year: "2024",
      milestone: "Achievements and Awards",
      details: [
        "Awarded Fintech Scale up of the Year",
        "Reached Milestone of 3K monthly Active Partners",
        "Hosted Welocity - Our first ever partners meet"
      ],
      visualElement: null,
      hasImage: true,
      imageUrl: `${WealthyEnv.HOMEPAGE_CDN_URL}/our-journey-card-2024-about-us.jpg`
    }
  ];

  const timelineSectionData = {
    title: "Our Journey through the years",
    bottomText: "🚀 Onwards and upwards - Building future ready investment solutions",
    buttonText: "Get in Touch"
  };

  const testimonialData = {
    headerIcon: `${WealthyEnv.HOMEPAGE_CDN_URL}/testimonial-clienthome.png`,
    headerText: "Testimonial",
    heading: "What our Wealth Partner's say",
    barAvatars: [
      `${WealthyEnv.HOMEPAGE_CDN_URL}/nihar-testimonial-about-us.png`,
      `${WealthyEnv.HOMEPAGE_CDN_URL}/meghana-testimonial-about-us.png`,
      `${WealthyEnv.HOMEPAGE_CDN_URL}/ghulam-testimonial-about-us.png`
    ],
    barText: "More than 10000+ Partners trust wealthy",
    viewAllText: "View all testimonials",
    showLessText: "Show less",
    testimonials: [
      {
        name: "Meghana R K, Bengaluru",
        role: "Wealth Partner",
        title: "Wealthy has the best support",
        stars: 4,
        text: "My Relationship Manager at Wealthy is a crucial support system to my business. From being just a call or WhatsApp message away, she enables me to focus on business generation while taking care of my operational needs.",
        avatar: `${WealthyEnv.HOMEPAGE_CDN_URL}/meghana-testimonial-about-us.png`
      },
      {
        name: "Nihar Mamtura, Pune",
        role: "Wealth Partner",
        title: "I serve global clients and sell multiple products, all in one app",
        stars: 5,
        text: "I have clients from the Middle East, South East Asia, and Europe and Wealthy's fully digital platform makes transactions seamless for them. The biggest advantage is that gives me the ability to sell multiple products such a mutual funds, stocks, and insurance within a single app.",
        avatar: `${WealthyEnv.HOMEPAGE_CDN_URL}/nihar-testimonial-about-us.png`
      },
      {
        name: "Birendra Sharma, Raipur",
        role: "Wealth Partner",
        title: "It has redefined how I manage client finances.",
        stars: 4,
        text: "Wealthy's platform is truly a game-changer. Apart from Mutual Funds, they offer Insurance, Bonds, FDs, PMS etc..that have revolutionized the way I handle my clients' finances. From portfolio tracking to research support it has everything I need.",
        avatar: `${WealthyEnv.HOMEPAGE_CDN_URL}/biredra-testimonial-about-us.png`
      },
      {
        name: "Varun Krishna, Bengaluru",
        role: "Wealth Partner",
        title: "Posters are very useful to attract new clients.",
        stars: 5,
        text: "Wealthy's platform, the Poster Gallery, is full of helpful marketing collateral, like trending news, SIP & Mutual Fund facts and investment updates. I highly recommend it to anyone who wants to stay ahead of the curve in the financial services industry.",
        avatar: `${WealthyEnv.HOMEPAGE_CDN_URL}/varun-testimonial-about-us.png`
      },
      {
        name: "Ratnamala Bashire, Pune",
        role: "Wealth Partner",
        title: "Comparing mutual funds is effortless.",
        stars: 4,
        text: "The ability to quickly compare mutual Wealthy's app gives me a bird's eye funds on various parameters and dive into the various ratios and other aspects is a huge plus point. It helps understand the various funds. ",
        avatar: `${WealthyEnv.CDN_URL}/articles/ratnamala-testimonial-about-us.png`
      },
      {
        name: "Gulam Abbas Nusur, Bengaluru",
        role: "Wealth Partner",
        title: "Wealthy gives me full business visibility.",
        stars: 4,
        text: "Wealthy's app gives me a bird's eye funds on various parameters and dive into the various ratios and other aspects is a huge plus point. It helps understand the various funds. view of client AUM, transactions, and revenue logs. Everything is at my fingertips and this makes it easy to run my business. ",
        avatar: `${WealthyEnv.HOMEPAGE_CDN_URL}/ghulam-testimonial-about-us.png`
      },
      {
        name: "Srinivas Reddy – Hyderabad, Telangana",
        role: "Wealth Partner",
        title: "Closing SIPs is now faster and easier",
        stars: 5,
        text: "Wealthy’s proposal builder helped me close SIPs faster than ever before. I used to spend hours preparing documents, now it only takes few minutes",
        avatar: `${WealthyEnv.HOMEPAGE_CDN_URL}/srinivas-testimonial-about-us.png`
      },
      {
        name: "Rohit Gupta, Kanpur",
        role: "Wealth Partner",
        title: "Revenue dashboard shows me exactly how my earnings are growing",
        stars: 4,
        text: "Wealthy's revenue dashboard gives me a clear breakdown of my earnings by product, client, and time period. It's helped me identify what's working, set better targets, and focus on growing my business",
        avatar: `${WealthyEnv.HOMEPAGE_CDN_URL}/rohit-testimonial-about-us.png`
      },
      {
        name: "Revathi Krishnan – Coimbatore, TN",
        role: "Wealth Partner",
        title: "Personalized onboarding page gives clients a great first impression",
        stars: 5,
        text: " The best part is I can create my own client onboarding page with my name and photo & attract new clients. I send one link, and they get everything they need to start",
        avatar: `${WealthyEnv.HOMEPAGE_CDN_URL}/revathi-testimonial-about-us.png`
      },
      {
        name: "Shubham Singh – New Delhi",
        role: "Wealth Partner",
        title: "Tracker is Wealthy's best feature",
        stars: 5,
        text: "I can now track all my clients' external portfolios in one place. This gives me a full picture of where their money is, so I can suggest better, smarter fund recommendations. It also helps me identify gaps or overlaps in their investments and tailor advice more precisely",
        avatar: `${WealthyEnv.HOMEPAGE_CDN_URL}/shubham-testimonial-about-us.png`
      }
    ]
  };

  return {
    props: {
      seoData,
      heroData,
      foundersData,
      teamData,
      teamSectionData,
      believeData,
      howWeWorkData,
      investorData,
      pressData,
      moneyOrderData,
      timelineData,
      timelineSectionData,
      testimonialData
    },
  };
}

const PageContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  background: #fff;
  overflow-x: hidden;
  box-sizing: border-box;

  overflow-x: hidden;
  #register, #register-thankyou, #share {
    transition: all 0s, opacity 300ms ease-in-out;
    opacity: 0;
    visibility: hidden;
  }
  #register:target, #register-thankyou:target, #share:target {
    transition: all 0s, opacity 300ms ease-in-out;
    opacity: 1;
    visibility: visible;
    position: fixed;
    z-index: 999;
    & > div > div {
      transform: translate(-50%, -50%);
      transition: all 0.25s ease-in-out;
    }
  }

  @media (max-width: 768px) {
    padding: 0;
  }
`;

const Section = styled.section`
  display: flex;
  justify-content: center;
  width: 85%;
  max-width: 125rem;
  margin: 0 auto;

  @media (max-width: 768px) {
    padding: 3rem 0 3rem 0;
    width:100%;
    max-width: 125rem;
  }
`;

const SectionInner = styled.div`
  width: 100%;
  margin: 0;
  margin-top: 10rem;
  padding: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media (max-width: 768px) {
    width: 85%;
    margin-top: 0;
  }
`;

const SectionTitleCenter = styled.p`
  font-size: 5rem;
  font-weight: 400;
  color: #1C1C1C;
  font-family: 'DM Serif Display';
  text-align: center;

  @media (max-width: 768px) {
    font-size: 2.7rem;
    margin-top: 2.4rem;
    margin-bottom: 2rem;
  }
`;

const SectionTitleCenter1 = styled.p`
  display: none;
  margin-top: 4rem;
  font-size: 5rem;
  color: #1C1C1C;
  font-family: 'DM Serif Display';
  text-align: center;

  @media (max-width: 768px) {
    display: block;
    font-size: 2.7rem;
    margin-top: 2.4rem;
    margin-bottom: 2rem;
  }
`;


const LetterButton = styled.a`
  font-family: 'Lato';
  height: 6.2rem;
  display: flex;
  justify-content: center;
  width: 30%;
  margin: 0 auto;
  align-items: center;
  background: #6725F4;
  color: #fff;
  border: none;
  border-radius: 100rem;
  padding: 1.4rem 3.2rem;
  font-size: 1.8rem;
  font-weight: 700;
  text-align: center;
  cursor: pointer;
  text-decoration: none;
  transition: background 0.2s;

  &:hover {
    background: #6725F4;
  }
    span {
    font-size: 2.8rem;
    }

  @media (max-width: 768px) {
    margin-top: 0.5rem;
    width: 100%;
  }
`;

const SectionSubtitle = styled.p`
  font-size: 2rem;
  font-family: 'Lato';
  font-weight: 400;
  color: #6F6F6F;
  text-align: center;
  max-width: 88.5rem;
  margin: 0 auto 40px auto;

  span {
    color: #1C1C1C;
  }

  @media (max-width: 768px) {
    font-size: 1.4rem;
    max-width: 100%;
    margin-bottom: 2.66rem;
  }
`;

const CardsRow = styled.div`
  display: flex;
  /* margin-top: 10rem; */
  gap: 4rem;
  width: 100%;
  margin: 0 auto 4rem auto;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 2rem;
    margin-bottom: 2rem;
  }
`;
export default aboutUsNew;